import { Phone, ChevronRight, CheckCheck as CheckCircle2, ShieldCheck, Star, ArrowRight, TriangleAlert as AlertTriangle } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
const HERO_IMG = {
  desktop: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/98e6b5da-5f28-4e7a-9644-2bf8351ab70d.webp",
  tablet: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/98e6b5da-5f28-4e7a-9644-2bf8351ab70d.webp",
  mobile: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/98e6b5da-5f28-4e7a-9644-2bf8351ab70d.webp"
};
const NAVY = "#081438";
const NAVY_LIGHT = "#243752";
const GOLD = "#F5A623";
const FONT_HEAD = "'Plus Jakarta Sans', system-ui, sans-serif";
const FONT_BODY = "'Manrope', system-ui, sans-serif";
const formFooterItems = [{
  text: "Free Inspection"
}, {
  text: "Phone Quote"
}, {
  text: "Trust Guarantee"
}];
export default function SpringHero() {
  return <section className="relative isolate overflow-hidden !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/98e6b5da-5f28-4e7a-9644-2bf8351ab70d-1.png)] !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/98e6b5da-5f28-4e7a-9644-2bf8351ab70d-2.png)] !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/98e6b5da-5f28-4e7a-9644-2bf8351ab70d.webp)]" style={{
    backgroundColor: NAVY
  }} aria-label="Garage Door Spring Replacement Sydney">
      <picture className="absolute inset-0 -z-10">
        <source media="(max-width: 767px)" srcSet={HERO_IMG.mobile} type="image/webp" />
        <source media="(max-width: 1279px)" srcSet={HERO_IMG.tablet} type="image/webp" />
        <img src={HERO_IMG.desktop} alt="Gold Garage Door technician replacing a torsion garage door spring in Sydney" className="h-full w-full object-cover" style={{
        objectPosition: "65% center"
      }} loading="eager"
      // @ts-ignore
      fetchpriority="high" decoding="async" width={1920} height={1440} />
      </picture>

      <div className="absolute inset-0 -z-10" style={{
      background: `linear-gradient(90deg, ${NAVY}F2 0%, ${NAVY}E6 40%, ${NAVY}B3 70%, ${NAVY}80 100%)`
    }} />
      <div className="absolute inset-0 -z-10" style={{
      background: `radial-gradient(ellipse at 20% 50%, ${NAVY_LIGHT}66 0%, transparent 50%), linear-gradient(180deg, ${NAVY}40 0%, transparent 30%, transparent 70%, ${NAVY} 100%)`
    }} />

      <div aria-hidden className="absolute inset-0 -z-10 opacity-[0.05] mix-blend-overlay pointer-events-none" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.9 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
    }} />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8 pt-28 md:pt-32 lg:pt-36 pb-20 md:pb-24 lg:pb-28">
        {}
        <nav aria-label="Breadcrumb" className="mb-10 flex items-center gap-2 text-[13px]" style={{
        fontFamily: FONT_BODY,
        color: "rgba(255,255,255,0.6)"
      }}>
          <Link to="/" className="hover:text-white transition-colors">Home</Link>
          <ChevronRight className="h-3.5 w-3.5 opacity-50" />
          <Link to="/OurServicesPage" className="hover:text-white transition-colors">
            Services
          </Link>
          <ChevronRight className="h-3.5 w-3.5 opacity-50" />
          <span style={{
          color: "rgba(255,255,255,0.95)"
        }}>Spring Replacement</span>
        </nav>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">

          {}
          <div className="lg:col-span-7">
            {}
            <div className="mb-6 inline-flex items-center gap-2.5 rounded-lg border px-4 py-2" style={{
            backgroundColor: "rgba(245,166,35,0.10)",
            borderColor: "rgba(245,166,35,0.30)"
          }}>
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-lg opacity-75" style={{
                backgroundColor: GOLD
              }} />
                <span className="relative inline-flex h-2 w-2 rounded-lg" style={{
                backgroundColor: GOLD
              }} />
              </span>
              <span className="text-[11px] font-semibold tracking-[0.18em] uppercase" style={{
              fontFamily: FONT_BODY,
              color: GOLD
            }}>
                Emergency · Same-Day · Sydney Wide
              </span>
            </div>

            {}
            <h1 className="font-extrabold text-white" style={{
            fontFamily: FONT_HEAD,
            fontSize: "clamp(2.25rem, 5vw, 4.25rem)",
            lineHeight: 1.05,
            letterSpacing: "-0.025em"
          }}>
              Snapped a Spring?{" "}
              <span style={{
              color: GOLD
            }}>Don&rsquo;t touch it.</span>{" "}
              We&rsquo;ll fix it today.
            </h1>

            {}
            <p className="mt-6 max-w-xl text-base md:text-lg leading-relaxed" style={{
            fontFamily: FONT_BODY,
            color: "rgba(255,255,255,0.82)"
          }}>
              Torsion and extension springs replaced same-day across Sydney.{" "}
              <span className="text-white font-semibold">
                Safety-critical work
              </span>{" "}
              — never DIY a broken spring. Fixed-price quotes, no callout fees,
              12-month workmanship warranty in writing.
            </p>

            {}
            <div className="mt-5 inline-flex items-start gap-3 rounded-xl border px-4 py-3 max-w-xl" style={{
            borderColor: "rgba(255,107,107,0.30)",
            backgroundColor: "rgba(255,107,107,0.08)"
          }}>
              <AlertTriangle className="flex-shrink-0 h-5 w-5 mt-0.5" strokeWidth={2.2} style={{
              color: "#FF6B6B"
            } as React.CSSProperties} />
              <p className="text-[12.5px] leading-snug" style={{
              color: "rgba(255,255,255,0.9)"
            }}>
                <span className="font-bold" style={{
                color: "#FF6B6B"
              }}>
                  Warning:
                </span>{" "}
                Broken garage door springs hold extreme tension. Never attempt
                DIY removal &mdash; call us immediately.
              </p>
            </div>

            {}
            <div className="mt-6 flex items-center gap-2 flex-wrap">
              <span className="text-[10px] font-bold tracking-[0.22em] uppercase" style={{
              color: "rgba(255,255,255,0.5)"
            }}>
                Springs for —
              </span>
              {["B&D", "Steel-Line", "Gliderol", "Merlin", "ATA", "DoorWorks", "Centurion"].map(brand => <span key={brand} className="text-[11px] font-bold tracking-wide rounded-lg px-2.5 py-1 border" style={{
              borderColor: "rgba(255,255,255,0.18)",
              backgroundColor: "rgba(255,255,255,0.04)",
              color: "rgba(255,255,255,0.85)",
              fontFamily: FONT_BODY
            }}>
                  {brand}
                </span>)}
            </div>

            {}
            <div className="mt-8 flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center gap-3">
              <Link to="tel:0485000933" aria-label="Call Gold Garage Door on 0485 000 933" className="group inline-flex items-center justify-center gap-3 rounded-lg px-7 py-[14px] text-[15px] font-bold transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]" style={{
              backgroundColor: GOLD,
              color: NAVY,
              fontFamily: FONT_BODY,
              boxShadow: `0 14px 40px -10px ${GOLD}99`
            }}>
                <Phone className="h-[18px] w-[18px]" strokeWidth={2.5} />
                Call 0485 000 933
              </Link>
              <Link to="https://wa.me/61485000933" className="group inline-flex items-center justify-center gap-2 rounded-lg border-2 px-7 py-3 text-[15px] font-semibold text-white transition-all duration-200" style={{
              borderColor: "rgba(255,255,255,0.35)",
              fontFamily: FONT_BODY
            }} onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.10)";
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.55)";
            }} onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.35)";
            }}>
                WhatsApp Us
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>

            {}
            <ul className="mt-10 flex flex-wrap gap-x-6 gap-y-3" style={{
            fontFamily: FONT_BODY
          }}>
              {[{
              icon: CheckCircle2,
              label: "Same-Day Replacement"
            }, {
              icon: ShieldCheck,
              label: "12-Month Warranty"
            }, {
              icon: Star,
              label: "5.0 Google Rated"
            }].map(({
              icon: Icon,
              label
            }) => <li key={label} className="flex items-center gap-2.5">
                  <Icon className="h-[18px] w-[18px] flex-shrink-0" strokeWidth={2} style={{
                color: GOLD
              } as React.CSSProperties} />
                  <span className="text-sm font-medium" style={{
                color: "rgba(255,255,255,0.92)"
              }}>
                    {label}
                  </span>
                </li>)}
            </ul>
          </div>

          {}
          <div id="contact-us" className="lg:col-span-5 relative bg-white backdrop-blur-sm p-6 md:p-8 rounded-lg border border-[#F5A623]/40 shadow-2xl shadow-[#081438]/10 overflow-hidden scroll-mt-28">
            <div className="absolute inset-0 opacity-[0.015] bg-[url('data:image/svg+xml,%3Csvg%20width=%22100%22%20height=%22100%22%20xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cpath%20d=%22M0%200h100v100H0z%22%20fill=%22%23081438%22/%3E%3C/svg%3E')] pointer-events-none rounded-lg" />
            <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#F5A623] via-[#ffc142] to-[#F5A623]" />
            
            <div className="text-center mb-6">
              <h2 className="text-xl font-bold text-[#081438] mb-1.5">Get Your Free Quote</h2>
              <p className="text-[13.5px] text-[#555] font-medium">Fast response · No obligation · No hidden fees</p>
              <div className="h-px bg-gradient-to-r from-transparent via-[#F5A623]/20 to-transparent my-4" />
            </div>

            <FormProvider formId="hero_quote_form" sectionName="Hero Section" defaultValues={{
            name: "",
            phone: "",
            suburb: "",
            service: ""
          }} successMessage="Your request has been received.">
              <QuoteFormContent />
            </FormProvider>

            <div className="mt-6 pt-4 border-t border-black/5 flex justify-center gap-5">
              {formFooterItems.map((item, i) => <div key={i} data-index={i} className="flex items-center gap-1.5">
                  <span className="text-[12px] font-semibold text-[#333]">{item.text}</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px" style={{
      background: `linear-gradient(90deg, transparent 0%, ${GOLD}80 50%, transparent 100%)`
    }} />
    </section>;
}
function QuoteFormContent() {
  const {
    isSubmitted,
    successMessage,
    resetForm
  } = useWvcForm();
  if (isSubmitted) {
    return <div className="flex flex-col items-center justify-center py-10 text-center" style={{
      fontFamily: FONT_BODY
    }}>
        <CheckCircle2 className="h-12 w-12 mb-3 text-[#F5A623]" />
        <div className="text-[#081438] font-semibold text-lg">
          {successMessage}
        </div>
        <p className="mt-1 text-sm text-[#555]">
          We&rsquo;ll be in touch within minutes.
        </p>
        <Button onClick={resetForm} variant="outline" className="mt-4 border-[#F5A623] text-[#F5A623] hover:bg-[#F5A623] hover:text-white">
          Send Another Request
        </Button>
      </div>;
  }
  return <HeroQuoteForm />;
}
function HeroQuoteForm() {
  const {
    control,
    handleSubmit,
    isSubmitting
  } = useWvcForm();
  return <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-3.5">
        <div className="grid grid-cols-1 gap-3.5">
          <input {...control.register("name", {
          required: true
        })} placeholder="Full Name" className="w-full rounded-lg border border-black/10 px-4 py-3 text-[15px] text-[#081438] placeholder:text-black/40 outline-none focus:border-[#F5A623] transition-all" />
          <div className="grid grid-cols-2 gap-3">
            <input {...control.register("phone", {
            required: true
          })} placeholder="Phone" type="tel" className="w-full rounded-lg border border-black/10 px-4 py-3 text-[15px] text-[#081438] placeholder:text-black/40 outline-none focus:border-[#F5A623] transition-all" />
            <input {...control.register("suburb", {
            required: true
          })} placeholder="Suburb" className="w-full rounded-lg border border-black/10 px-4 py-3 text-[15px] text-[#081438] placeholder:text-black/40 outline-none focus:border-[#F5A623] transition-all" />
          </div>
          <select {...control.register("service")} className="w-full rounded-lg border border-black/10 px-4 py-3 text-[15px] text-[#081438] outline-none focus:border-[#F5A623] transition-all appearance-none bg-white" style={{
          backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23F5A623' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>\")",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 14px center",
          paddingRight: "40px"
        }}>
            <option value="">Select Spring Issue</option>
            <option value="Snapped Torsion Spring">Snapped Torsion Spring</option>
            <option value="Broken Extension Spring">Broken Extension Spring</option>
            <option value="Door Won't Lift / Too Heavy">Door Won't Lift / Too Heavy</option>
            <option value="Replace Both Springs">Replace Both Springs</option>
            <option value="Worn / Noisy Springs">Worn / Noisy Springs</option>
            <option value="Other / Not Sure">Other / Not Sure</option>
          </select>
        </div>

        <Button type="submit" disabled={isSubmitting} className="w-full h-auto py-4 bg-[#F5A623] hover:bg-[#ffc142] text-[#081438] font-bold text-[16px] rounded-lg shadow-lg shadow-[#F5A623]/20 transition-all active:scale-[0.98]">
          {isSubmitting ? "Sending..." : "Request My Free Quote"}
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>

        <p className="text-[11px] text-center text-[#777]">
          No spam · Reply within 60 min during business hours
        </p>
      </div>
    </form>;
}